import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

// import realEstateManagementReducer from "../../modules/realEstateManagement/reducers";
import agendaReducer from '../../modules/agenda/reducers';
import authReducer from '../../modules/auth/reducers';
import buildingReducer from '../../modules/building/reducers';
import dashboardReducer from '../../modules/dashboard/reducers';
import dwellingReducer from '../../modules/dwelling/reducers';
import teamReducer from '../../modules/myTeam/reducers';
import orderReducer from '../../modules/order/reducers';
import referentialReducer from '../../modules/referential/reducers';
import history from '../../routes/history';
import ordersReducer from './../../modules/orders/reducers';
import reducers from './../../modules/profile/reducers/index';
import serviceOrderingReducer from './../../modules/serviceOrdering/reducers/index';

const { groupReducer, agencyReducer } = reducers;

export default combineReducers({
  agendaReducer,
  authReducer,
  buildingReducer,
  serviceOrderingReducer,
  groupReducer,
  agencyReducer,
  dwellingReducer,
  ordersReducer,
  teamReducer,
  referentialReducer,
  orderReducer,
  dashboardReducer,
  // realEstateManagementReducer,
  router: connectRouter(history)
});
